import React from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Slider,
  Divider,
  Button,
  alpha,
} from '@mui/material';
import { Mic, Videocam } from '@mui/icons-material';

interface VoiceVideoTabProps {
  colors: any;
  glassStyle: any;
  isDark: boolean;
}

const VoiceVideoTab: React.FC<VoiceVideoTabProps> = ({ colors, glassStyle, isDark }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Voice & Video
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Typography fontWeight={700} color={colors.textPrimary} sx={{ mb: 2 }}>
          Input Device
        </Typography>
        <FormControl fullWidth variant="filled" sx={{ mb: 4 }}>
          <InputLabel sx={{ color: colors.textSecondary }}>Default</InputLabel>
          <Select 
            value={10} 
            sx={{ 
              bgcolor: isDark ? alpha(colors.textSecondary, 0.1) : '#f5f5f5', 
              borderRadius: '12px' 
            }} 
            disableUnderline
          >
            <MenuItem value={10}>Default</MenuItem>
            <MenuItem value={20}>Microphone (Realtek Audio)</MenuItem>
          </Select>
        </FormControl>
        
        <Typography fontWeight={700} color={colors.textPrimary} sx={{ mb: 1 }}>
          Input Volume
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid>
            <Mic sx={{ color: colors.textSecondary }} />
          </Grid>
          <Grid size="grow">
            <Slider defaultValue={70} sx={{ color: colors.accent }} />
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: colors.borderColor }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontWeight={700} color={colors.textPrimary}>Video Settings</Typography>
          <Button 
            variant="contained" 
            sx={{ 
              bgcolor: colors.sidebarBg, 
              color: colors.textPrimary, 
              borderRadius: '20px', 
              textTransform: 'none' 
            }}
          >
            Test Video
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default VoiceVideoTab;